import { useEffect } from "react";
import { useRtkQueryDynamicEndpoint } from "../../../../common/hooks/useRtkQueryDynamicEndpoint";
import { useLazyGetContractsQuery } from "../../../../requests_cm/gecoContractsService/service";
import { GetOneSiteResponseType } from "../../../../requests_cm/gecoSitesService/types";
import ContractTab from "./ContractsTab";

export const ContractsTabContainer = ({
	site,
}: {
	site: GetOneSiteResponseType;
}) => {
	const [baseGetContracts, { data: contracts, isLoading }] =
		useLazyGetContractsQuery();

	const getContracts = useRtkQueryDynamicEndpoint(baseGetContracts);

	useEffect(() => {
		if (site) {
				const contractIds = site.service_points.flatMap(sp => sp.contractperiods.map(cp => cp.contract.id))
				if (contractIds.length > 0) {
					getContracts({filters: {id__in: contractIds},  page: 1});
				}
		}
	}, [site]);

	return (
		<ContractTab
			isLoading={isLoading}
			contracts={contracts?.result || []}
		/>
	);
};
